import classNames from 'classnames';
import I18n from 'i18n-js';
import { bool, string } from 'prop-types';

import { ENGLISH, FRENCH, GERMAN, SPANISH } from '@lootboy/translations/config';

import GooglePlayBadge from '~/components/AppBadges/GooglePlayBadge';

import appGalleryDe from '~/assets/images/app-badges/appGallery-de.svg';
import appGalleryEn from '~/assets/images/app-badges/appGallery-en.svg';
import appGalleryEs from '~/assets/images/app-badges/appGallery-es.svg';
import appGalleryFr from '~/assets/images/app-badges/appGallery-fr.svg';
import appStoreDe from '~/assets/images/app-badges/appStore-de.svg';
import appStoreEn from '~/assets/images/app-badges/appStore-en.svg';
import appStoreEs from '~/assets/images/app-badges/appStore-es.svg';
import appStoreFr from '~/assets/images/app-badges/appStore-fr.svg';

import Badge from './Badge';

import styles from './AppBadges.module.scss';

const appStore = {
  [GERMAN]: appStoreDe,
  [ENGLISH]: appStoreEn,
  [SPANISH]: appStoreEs,
  [FRENCH]: appStoreFr,
};

const appGallery = {
  [GERMAN]: appGalleryDe,
  [ENGLISH]: appGalleryEn,
  [SPANISH]: appGalleryEs,
  [FRENCH]: appGalleryFr,
};

const AppBadges = ({ className, recruiter }) => {
  return (
    <div className={classNames(styles.storeBadges, className)}>
      <GooglePlayBadge recruiter={recruiter} />
      <Badge
        href={I18n.t('common_apple_app_store_url')}
        images={appStore}
        title="applestore"
      />
      <Badge
        href={I18n.t('common_huawei_appgallery_url')}
        images={appGallery}
        title="appgallery"
      />
    </div>
  );
};

AppBadges.propTypes = {
  className: string,
  badgeClassName: string,
  skipUnimportant: bool,
  recruiter: string,
};

export default AppBadges;
